import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../../api/admin";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);

  const fetchUsers = async () => {
    const resp = await adminApi.getUsers({ q: search, skip: page * 20, limit: 20 });
    setUsers(resp.data.users); setTotal(resp.data.total);
  };

  useEffect(() => { fetchUsers(); }, [search, page]);

  return (
    <div>
      <h1 className="font-clash text-2xl font-bold text-white mb-6">Users</h1>
      <input type="text" placeholder="Search by email or name..." value={search} onChange={(e) => { setSearch(e.target.value); setPage(0); }}
        className="w-full max-w-md bg-[#1a1a1e] border border-white/10 rounded px-4 py-3 text-white mb-6 focus:border-[#FF5500] focus:outline-none" />
      <div className="space-y-2">
        {users.map((u) => (
          <Link key={u._id} to={`/admin/users/${u._id}`} className="feature-card rounded-lg px-6 py-4 flex flex-wrap items-center justify-between gap-2 hover:bg-white/5 transition-colors">
            <div className="min-w-0">
              <p className="text-white text-sm">{u.name}</p>
              <p className="text-xs text-[#A1A1AA] break-all">{u.email}</p>
            </div>
            <span className={`text-xs px-2 py-1 rounded ${u.role === "admin" ? "bg-[#FF5500]/10 text-[#FF5500]" : "bg-white/5 text-[#A1A1AA]"}`}>{u.role}</span>
          </Link>
        ))}
      </div>
      <div className="flex items-center justify-between mt-6">
        <span className="text-xs text-[#A1A1AA]">{total} users total</span>
        <div className="flex gap-2">
          <button disabled={page === 0} onClick={() => setPage(page - 1)} className="text-xs text-[#A1A1AA] hover:text-white disabled:opacity-30">Prev</button>
          <button disabled={(page + 1) * 20 >= total} onClick={() => setPage(page + 1)} className="text-xs text-[#A1A1AA] hover:text-white disabled:opacity-30">Next</button>
        </div>
      </div>
    </div>
  );
}
